import { Pipe, PipeTransform } from '@angular/core';
import { images } from '../environments/environment';

@Pipe({
  name: 'bucket',
  standalone: true
})
export class BucketPipe implements PipeTransform {
  bucket: string = images;

  transform(url: string|undefined, performance: boolean = false): string|undefined {
    if(url?.startsWith('/')){
      if(performance && url.includes('/quality')){
        url = url.replace('/quality', '/performance').split('.').slice(0, -1).join('.') + '.webp';
      }
      return this.bucket + url;
    }

    return url;
  }

}
